// src/components/CompletedStep.jsx
import React from "react";
import { Check, Download, Eye, LayoutGrid, Info } from "lucide-react";
import { company } from "./data/mockData";

export default function CompletedStep({ consentId, timestamp, onDownload, onViewConsents, onGoToDashboard, recipientEmail }) {
  return (
    <section
      style={{
        background: "#fff",
        borderRadius: "var(--radius-lg)",
        border: "1px solid var(--gray-200)",
        boxShadow: "var(--shadow-sm)",
        padding: "20px 28px 28px",
        width: "100%",
      }}
    >
      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: "var(--blue-700)",
          background: "var(--blue-50)",
          padding: "3px 9px",
          borderRadius: 5,
          letterSpacing: 0.3,
        }}
      >
        STEP 4 OF 4
      </span>
      <h2 style={{ fontSize: 21, fontWeight: 700, color: "var(--gray-900)", margin: "10px 0 4px" }}>
        Consent Submitted Successfully!
      </h2>
      <p style={{ fontSize: 13.5, color: "var(--gray-500)", margin: "0 0 20px" }}>
        Thank you for providing your consent.
      </p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 18,
          padding: "8px 4px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
          <span
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: "var(--green-600)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Check size={28} color="#fff" strokeWidth={3} />
          </span>
          <div>
            <p style={{ fontSize: 13.5, color: "var(--gray-700)", margin: "0 0 6px", fontWeight: 500 }}>
              Your consent has been recorded successfully.
            </p>
            <p style={{ fontSize: 13, color: "var(--gray-600)", margin: "0 0 3px" }}>
              Consent ID: <strong style={{ color: "var(--gray-900)" }}>{consentId}</strong>
            </p>
            <p style={{ fontSize: 13, color: "var(--gray-600)", margin: 0 }}>
              Date &amp; Time: {timestamp}
            </p>
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <ActionButton icon={Download} label="Download Receipt" onClick={onDownload} />
          <ActionButton icon={Eye} label="View My Consents" onClick={onViewConsents} />
          <ActionButton icon={LayoutGrid} label="Go to Dashboard" onClick={onGoToDashboard} />
        </div>
      </div>

      {(recipientEmail || company.userEmail) && (
        <div
          style={{
            marginTop: 22,
            background: "var(--blue-50)",
            border: "1px solid var(--blue-100)",
            borderRadius: "var(--radius-md)",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
            gap: 9,
          }}
        >
          <Info size={15} style={{ color: "var(--blue-700)", flexShrink: 0 }} />
          <span style={{ fontSize: 13, color: "var(--gray-700)" }}>
            {recipientEmail
              ? `A copy of your consent has been sent to ${recipientEmail}`
              : `A copy of your consent has been recorded for ${company.userEmail}`}
          </span>
        </div>
      )}
    </section>
  );
}

function ActionButton({ icon: Icon, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 7,
        background: "#fff",
        border: "1px solid var(--gray-200)",
        color: "var(--blue-700)",
        borderRadius: 8,
        padding: "10px 14px",
        fontSize: 13,
        fontWeight: 600,
        cursor: "pointer",
        whiteSpace: "nowrap",
      }}
    >
      <Icon size={14} />
      {label}
    </button>
  );
}
